import React from 'react';

import { Box, Divider } from '@chakra-ui/react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const NoDropLine = () => (
  <Box position="relative" display="flex" justifyContent="center">
    <Divider position="absolute" left="0" right="0" top="50%" opacity={1} borderColor="#C62C02" />
    <Box
      sx={{
        background: '#FFE1D9',
        padding: '2px 24px',
        borderRadius: '4px',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
      }}
      display="flex"
      alignItems="center"
    >
      <TextBodyMedium>You cannot move agenda points between admin added points</TextBodyMedium>
    </Box>
  </Box>
);

export { NoDropLine };
